export const parameterValueMap = {
  // Green (Low-Risk) = 1
  Low: 1,
  Mature: 1,
  Reliable: 1,
  Positive: 1,
  "No Lawsuits": 1,
  "No AML Activities": 1,
  Complied: 1,
  Decentralized: 1,
  "✅ Compliant": 1,

  // Yellow (Medium-Risk) = 2
  Medium: 2,
  Anonymous: 2,
  Standard: 2,

  // Red (High-Risk) = 3
  High: 3,
  Immature: 3,
  Unreliable: 3,
  Negative: 3,
  "Lawsuits Exist": 3,
  "AML Activities": 3,
  "Not Complied": 3,
  Limited: 3,
  Centralized: 3,
  "❌ Non-compliant": 3,
};

const getNumericValue = (parameterName, parameterValue) => {
  // Special case for Uptime where 'High' is good (low risk)
  if (parameterName === "uptime") {
    if (parameterValue === "High") return 1;
    if (parameterValue === "Standard") return 2;
    if (parameterValue === "Limited") return 3;
    return 0;
  }

  // For all other parameters, use the standard mapping
  return parameterValueMap[parameterValue] || 0;
};

export const calculateTabRiskScore = (tabData, parameterKeys) => {
  if (!tabData) return 0;

  let totalValue = 0;
  let valuedParametersCount = 0;

  // Handle standard parameters
  parameterKeys.forEach((key) => {
    const stringValue = tabData[key];
    if (stringValue) {
      const numericValue = getNumericValue(key, stringValue);
      if (numericValue > 0) {
        totalValue += numericValue;
        valuedParametersCount++;
      }
    }
  });

  // Handle additional parameters
  if (
    tabData.additionalParameters &&
    Array.isArray(tabData.additionalParameters)
  ) {
    tabData.additionalParameters.forEach((param) => {
      if (param.value) {
        const numericValue = getNumericValue("additional", param.value);
        if (numericValue > 0) {
          totalValue += numericValue;
          valuedParametersCount++;
        }
      }
    });
  }

  if (valuedParametersCount === 0) {
    return 0;
  }

  const score = totalValue / valuedParametersCount;
  return parseFloat(score.toFixed(3));
};

export const getRiskLevelInfo = (score) => {
  // || score === 0 || score === "0.00"
  if (!score && score !== 0 && score !== "0.00") {
    return {
      level: "Not Assessed",
      color: "gray",
      textColor: "text-gray-500",
      bgColor: "bg-gray-100",
      borderColor: "border-gray-200",
    };
  }
  if (score >= 0 && score <= 1.25) {
    return {
      level: "Low Risk",
      color: "green",
      textColor: "text-green-700",
      bgColor: "bg-green-100",
      borderColor: "border-green-200",
    };
  }
  if (score <= 1.75) {
    return {
      level: "Low – Medium Risk",
      color: "green",
      textColor: "text-green-700",
      bgColor: "bg-green-100",
      borderColor: "border-green-200",
    };
  }
  if (score <= 2.25) {
    return {
      level: "Medium Risk",
      color: "yellow",
      textColor: "text-yellow-700",
      bgColor: "bg-yellow-100",
      borderColor: "border-yellow-200",
    };
  }
  if (score <= 2.75) {
    return {
      level: "Medium – High Risk",
      color: "red",
      textColor: "text-red-700",
      bgColor: "bg-red-100",
      borderColor: "border-red-200",
    };
  }
  if (score <= 3.0) {
    return {
      level: "High Risk",
      color: "red",
      textColor: "text-red-700",
      bgColor: "bg-red-100",
      borderColor: "border-red-200",
    };
  }
  return {
    level: "Not Assessed",
    color: "gray",
    textColor: "text-gray-500",
    bgColor: "bg-gray-100",
    borderColor: "border-gray-200",
  };
};
